import React from "react";
import { FileExcelOutlined } from "@ant-design/icons";
// Common Components
import { DynamicDropdown, Button, FileDownloader, Modal, StaticDropdown } from "src/Components";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Local Components
import AggregateTable from "./AggregateTable";
import AssignmentForm from "./AssignmentForm";
import { Additional } from "./Additional";
// Requests
import { getUsers } from "src/Requests/connections";
import {
  getPortfolioGroupDropDown,
  getUserPortfoGroupExcel,
  getUserPortfoGroupTable,
} from "src/Requests/portfolioGroups";
// Interfaces
import type {
  IUserPortfoGroupSearchParams,
  IUserPortfoGroupTableReport,
} from "src/Interfaces/portfolioGroups";
import { exchangeTypeOptions } from "src/Utils/exchangeTypeOptions";

const AccountAssignment = () => {
  const [isAssignmentModalOpen, setIsAssignmentModalOpen] =
    React.useState(false);
  const [refreshFlag, setRefreshFlag] = React.useState(false);
  const [searchParams, setSearchParams] =
    React.useState<IUserPortfoGroupSearchParams>({
      sahraUserId: null,
      portfolioGroupId: null,
      exchangeType: null,
    });

  React.useEffect(() => {
    if (refreshFlag) setRefreshFlag(false);
  }, [refreshFlag]);

  const refreshTables = () => setRefreshFlag(true);

  const filterChangeHandler = (name: string, value: number | string) => {
    setSearchParams((prev) => ({
      ...prev,
      [name]: value === "" || value == null ? null : Number(value),
    }));
  };

  return (
    <div className="w-full">
      {isAssignmentModalOpen ? (
        <Modal
          title="تخصیص اکانت"
          UI={
            <AssignmentForm
              onSuccess={refreshTables}
              onClose={() => setIsAssignmentModalOpen(false)}
            />
          }
          onClose={() => setIsAssignmentModalOpen(false)}
          modalBoxClassName="!min-w-[360px]"
        />
      ) : null}

      <div
        className="grid w-full grid-cols-1 xl:grid-cols-[240px_minmax(0,1fr)_400px] gap-6 items-start"
        dir="ltr"
      >
        <div className="flex w-[220px] flex-col gap-2 xl:mt-[10px]" dir="rtl">
          <Button
            text="تخصیص اکانت"
            variant="contained"
            onClick={() => setIsAssignmentModalOpen(true)}
          />
          <FileDownloader
            getFile={() => getUserPortfoGroupExcel(searchParams)}
            text={
              <div className="flex items-center justify-center gap-2 rounded-md border-2 border-sky-600 px-2 py-1 text-sky-600 cursor-pointer">
                <FileExcelOutlined />
                دانلود اکسل
              </div>
            }
          />
        </div>

        <div className="flex flex-col min-w-0 gap-3 xl:mt-[58px]" dir="rtl">
          <TableTemplate<
            IUserPortfoGroupSearchParams,
            IUserPortfoGroupTableReport
          >
            getDataTable={getUserPortfoGroupTable}
            searchParameters={searchParams}
            withSort
            TableUI={({ reports, onAction, sortingType, setSortingType }) => (
              <CommonTableUI
                reports={reports}
                onAction={onAction}
                AdditionalBody={Additional}
                sortingType={sortingType}
                setSortingType={setSortingType}
                tableBoxClassName="!mx-0 max-h-[500px]"
                refreshFlag={refreshFlag}
                withSelect
              />
            )}
            tableWrapperClassname="!mx-0"
            refreshTableTime={30000}
            pagesize={200}
          />
        </div>

        <div className="flex flex-col gap-3" dir="rtl">
          <div className="flex flex-row justify-end items-end gap-3">
            <div className="w-[190px]">
              <DynamicDropdown
                dropdown={{
                  name: "sahraUserId",
                  placeholder: "اکانت",
                  extraLabel: true,
                }}
                getData={getUsers}
                onChange={filterChangeHandler}
                value={searchParams.sahraUserId?.toString() ?? ""}
              />
            </div>
            <div className="w-[190px]">
              <DynamicDropdown
                dropdown={{
                  name: "portfolioGroupId",
                  placeholder: "گروه پرتفو",
                  extraLabel: true,
                }}
                getData={getPortfolioGroupDropDown}
                onChange={filterChangeHandler}
                value={searchParams.portfolioGroupId?.toString() ?? ""}
              />
            </div>
            <div className="w-[190px]">
              <StaticDropdown
                dropdown={{
                  name: "exchangeType",
                  placeholder: " بورس",
                  extraLabel: true,
                }}
                options={exchangeTypeOptions}
                onChange={filterChangeHandler}
                value={searchParams.exchangeType?.toString() ?? ""}
              />
            </div>
          </div>

          <AggregateTable
            refreshFlag={refreshFlag}
            activePortfoGroupId={searchParams.portfolioGroupId ?? null}
            onPortfoGroupClick={(portfolioGroupId) =>
              setSearchParams((prev) => ({
                ...prev,
                portfolioGroupId,
              }))
            }
          />
        </div>
      </div>
    </div>
  );
};

export default AccountAssignment;
